import { getLocale } from '@amzn/bf-i18n'
import type { Unsubscribe } from '@amazon/vinyl-util'

const UNSET_LOCALE = 'und'
const FALLBACK_LANGUAGE = 'en'

/** The primary language subtag of a BCP-47 locale (`de` for `de-DE`), English while none is set. */
export function pageLanguageOf(locale: string): string {
    const language = locale === UNSET_LOCALE ? '' : locale.substring(0, 2).replace(/[^a-zA-Z]/g, '')
    return language.toLowerCase() || FALLBACK_LANGUAGE
}

/** Keeps `<html lang>` on the display language so assistive technology reads the page in it. */
export function installPageLanguage(): Unsubscribe {
    return getLocale().onData((locale) => {
        document.documentElement.setAttribute('lang', pageLanguageOf(locale))
    })
}
